import React from "react";
import styled from "styled-components";
import noIconTeamCodes from "Const/noIconTeamCodes";
import media from "cssMix/index";
import { Map } from "immutable";
import Slider from "react-slick";
import useMediaQuery from "useHooks/useMediaQuery";

const FeaturedGamesWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  & .title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
    margin: 0 0 20px;
  }
  ${media.tablet`
  margin-bottom:30px;
  & .title{
    font-size: 18px;
  }
  `}
`;

const GameCard = styled.div`
  display: flex !important;
  align-items: flex-end;
  height: 150px;
  width: 90% !important;
  flex-shrink: 0;
  margin-right: 2%;
  position: relative;

  &.new::after {
    content: "";
    right: -28px;
    bottom: 15px;
    width: 76px;
    height: 76px;
    position: absolute;
    z-index: 4;
    background: url("images/tag_hot.png") no-repeat;
  }
  &.hot::before {
    content: "";
    left: -8px;
    top: -8px;
    width: 76px;
    height: 76px;
    position: absolute;
    z-index: 4;
    background: url("images/tag_new.png") no-repeat;
  }
  .gameCardimg {
    width: 100%;
    height: 120px;
    background: url(${({ backgroundHorizontal }) => backgroundHorizontal});
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-size: 18px;
    position: relative;
    cursor: pointer;
    transform: translate3d(0, 0, 0);
    ${({ maintain }) =>
      maintain &&
      `
        pointer-events:none;
        cursor: not-allowed;
    `}
    .maintain {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.75;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;
      color: #ffffff;
      z-index: 6;
      cursor: none;
      pointer-events: none;
      > img {
        width: 50px;
        height: 50px;
        margin-bottom: 16px;
      }
    }
    .gameLogo {
      width: 130px;
      height: 130px;
      position: absolute;
      top: -30px;
    }
    transition: all 0.3s ease-in;
    transform: scale(1);
  }
  .gameCardTitle {
    color: ${({ theme }) => theme.colors["6"]};
    margin-bottom: 9px;
  }
  .gameCardType {
    font-size: 13px;
    color: ${({ theme }) => theme.colors["4"]};
    padding: 3px 10px;
    border: 1px solid ${({ theme }) => theme.colors["4"]};
    border-radius: 12.5px;
  }

  ${media.tablet`
    width:18%;
    height:100px;
        .gameCardimg{
            height:80px;
            background:url(${({ backgroundVertial }) => backgroundVertial});
            background-size:100% 100%;
             .maintain{
                font-size:14px;
                >img{
                    width:42px;
                }
                .text {
                  padding: 0 7px;
                }
            }
            .gameLogo{
                width:90px;
                height:90px;
                top:-20px;
            }
            .hoverBg{
                display:none;
            }
           .heart{
               top:-7px;
               right:7px;
           }
           &:hover{
            transform: none;
           }
        }
        .gameCardTitle{
        margin-bottom:0;
        }
        .gameCardType{
                display:none;           
            }
    `}
  ${media.mobile`
  height:85px;

  .gameCardimg{
    height:65px;
    .gameLogo{
                width:75px;
                height:75px;
                top:-20px;
            }
  }
    width:31%;
    `}
`;
const Shadow = styled.div`
  position: absolute;
  right: 0;
  top: 62px;
  width: 134px;
  height: 150px;
  background-image: linear-gradient(
    to right,
    rgba(33, 29, 90, 0) 4%,
    #201e5d 90%
  );
  ${media.tablet`
  top: 45px;
  height: 100px;
  `}
  ${media.mobile`
  height:85px;
  `}
`;
const FeaturedGames = ({
  t,
  gameList,
  typeList,
  lang,
  favorite_game,
  handleOpenPopModal,
}) => {
  const { mediaType } = useMediaQuery();
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    swipeToSlide: true,
    arrows: false,
    speed: 500,
    slidesToShow:
      mediaType === "mobile"
        ? gameList.size < 3
          ? gameList.size
          : 3
        : gameList.size < 5
        ? gameList.size
        : 5,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease",
  };
  return (
    <FeaturedGamesWrapper>
      <p className="title">{t("recommend")}</p>
      <Slider {...settings}>
        {gameList.map((v, i) => {
          const game_id = v.get("game_id");
          const type = typeList
            .find((type) => type.get("id") === v.get("type"), null, Map())
            .getIn(["name", lang]);
          const icon = v.getIn(["icon", lang], v.getIn(["icon", "en"]));
          const backgroundHorizontal = v.getIn([
            "background",
            "horizontal",
            lang,
          ]);
          const backgroundVertial = v.getIn(["background", "vertical", lang]);
          const name = v.getIn(
            ["name", lang],
            v.getIn(["name", "en"], "no default name")
          );
          const isFavorite = favorite_game.includes(game_id) || false;
          const maintain = v.get("maintain", false);
          const team = v.get("team", "");
          const isNoIconGame = noIconTeamCodes.includes(team);
          return (
            <GameCard
              key={game_id}
              backgroundHorizontal={backgroundHorizontal}
              backgroundVertial={backgroundVertial}
              ga-gameid={game_id}
              maintain={maintain}
            >
              <div
                className="gameCardimg"
                onClick={(e) =>
                  !maintain &&
                  handleOpenPopModal({
                    game_id,
                    icon,
                    type,
                    isFavorite,
                    name,
                    source: "featured",
                  })
                }
              >
                {maintain && (
                  <div className="maintain">
                    <img alt="" src={`images/maintain.png`} />
                    <div className="text">{t("maintain")}</div>
                  </div>
                )}
                {!isNoIconGame && (
                  <img className="gameLogo" alt="" src={icon} />
                )}
              </div>
            </GameCard>
          );
        })}
      </Slider>
      {gameList.size > 5 && <Shadow />}
    </FeaturedGamesWrapper>
  );
};

export default FeaturedGames;
